import clsx from "clsx";
import { whatDecimalSeparator } from "../../helpers";

export const Decimal = ({
  amount,
  decimals = 8,
  round = 6,
  symbol,
  symbolLeft,
  className,
  onClick,
  as: Component = "div",
  symbolClassName,
  subscript,
}: {
  amount: bigint;
  decimals?: number;
  round?: number;
  symbol?: string;
  symbolLeft?: boolean;
  className?: string;
  onClick?: () => void;
  as?: React.ElementType;
  symbolClassName?: string;
  subscript?: boolean;
}) => {
  const dec = amount % BigInt(10 ** decimals);
  const int = BigInt(Math.round(Number(amount - dec) / 10 ** decimals));
  const padded = dec.toString().padStart(decimals, "0");
  const truncated = subscript ? compress(padded) : padded;

  const trimmed = truncated.substring(0, round);

  return (
    <Component
      className={clsx({
        decimal: true,
        "decimal--label-left": symbolLeft,
        [`${className}`]: className,
      })}
      onClick={onClick}>
      <span className="decimal__int">
        {(int || "0").toLocaleString()}
        {round > 0 && whatDecimalSeparator()}
      </span>
      {dec.toString().length && round > 0 && (
        <span className="decimal__dec">{trimmed}</span>
      )}
      {symbol && (
        <span
          className={clsx({
            decimal__symbol: true,
            [`${symbolClassName}`]: symbolClassName,
          })}>
          {symbol}
        </span>
      )}
    </Component>
  );
};

const compress = (v: string): string => {
  const matches = v.match(/^(0+)([0-9]+)/);
  if (!matches) return v;
  const count = matches[1].length;

  if (count <= 2) return v;

  const sub = {
    "0": "\u2080",
    "1": "\u2081",
    "2": "\u2082",
    "3": "\u2083",
    "4": "\u2084",
    "5": "\u2085",
    "6": "\u2086",
    "7": "\u2087",
    "8": "\u2088",
    "9": "\u2089",
  }[count];

  return "\u0030" + sub + matches[2];
};
